import * as React from 'react';
import { IMotiveLogoInfo } from './dtp-resources.controller';

export interface IDtpResourcesGalleryProps {
    motives: IMotiveLogoInfo[];
    apiUrl: string;
}

export const DtpResourcesGallery = (props: IDtpResourcesGalleryProps) => {
    return (
        <div className="motives-gallery">
        {props.motives.map((item, index) =>
            <div className={"motive-item " + item.variant} key={'div-' + index + item.logoId + '-' + item.variant}>
                <div className="image-container">
                    <img key={'img-' + index + item.logoId + '-' + item.variant} src={`${props.apiUrl}/motive/${item.logoId}?variant=${item.variant}`} />
                </div>
                {item.customColor &&
                    <div className="custom-color-label">Custom color: <div className="color-preview" style={{backgroundColor: item.customColor}} />{item.customColor}</div>
                }
                <a href={`${props.apiUrl}/motive/${item.logoId}/download`} download={true}>
                    <button>Download Original File</button>
                </a>
            </div>
        )}
    </div>
    )
}



// WEBPACK FOOTER //
// ./src/App/dtp-portal/dtp-resources/dtp-resources-gallery.component.tsx